export default "__VITE_ASSET__177f6730__"